"use client";

import { useState } from "react";
import { ErrorPageContent } from "@/components/shared/ErrorPage";
import { AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { PortalModal } from "@/components/ui/portal-modal";
import { Bug, Eye, AlertTriangle } from "lucide-react";

// Component that throws an error when rendered
const ErrorThrower = () => {
  throw new Error("Dev Helper: Test runtime error triggered");
};

export const ErrorsFeature = () => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [shouldThrowError, setShouldThrowError] = useState(false);

  const handlePreviewError = () => {
    setPreviewOpen(true);
  };

  const handleCreateRuntimeError = () => {
    setShouldThrowError(true);
  };

  // If error should be thrown, render the error thrower component
  if (shouldThrowError) {
    return <ErrorThrower />;
  }

  // Sample error for preview
  const sampleError = new Error("Dev Helper: Test runtime error triggered");
  sampleError.stack = `Error: Dev Helper: Test runtime error triggered
    at ErrorThrower (ErrorsFeature.tsx:11:9)
    at ErrorsFeature (ErrorsFeature.tsx:30:5)
    at renderWithHooks (react-dom.development.js:16305:1)
    at updateFunctionComponent (react-dom.development.js:19588:1)`;

  return (
    <>
      <AccordionItem value="errors" className="rounded-large border-container bg-cede-bg-component/60 overflow-hidden">
        <AccordionTrigger className="px-4 py-3">
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-4 w-4" />
            <span className="font-semibold">Errors</span>
          </div>
        </AccordionTrigger>
        <AccordionContent className="px-4 py-3 space-y-2">
          <Button variant="secondary" size="medium" className="w-full justify-start" onClick={handlePreviewError}>
            <Eye className="h-4 w-4 mr-2" />
            Preview Error Page
          </Button>
          <Button
            variant="destructive"
            size="medium"
            className="w-full justify-start bg-cede-error/25 hover:bg-cede-error/35 text-cede-error"
            onClick={handleCreateRuntimeError}
          >
            <Bug className="h-4 w-4 mr-2" />
            Create Runtime Error
          </Button>
        </AccordionContent>
      </AccordionItem>

      <PortalModal
        open={previewOpen}
        onOpenChange={setPreviewOpen}
        className="w-full max-w-md mx-auto max-h-[90vh] overflow-y-auto"
      >
        <PortalModal.Content className="pt-6">
          <ErrorPageContent error={sampleError} showErrorDetails={true} />
        </PortalModal.Content>
      </PortalModal>
    </>
  );
};
